/**
 * Способы получения заказа и их цена.
 *
 * NOTE: пара к DELIVERY_RUSSIA_RUB / DELIVERY_PICKUP_RUB в
 * packages/shared-py/letsshine_shared/pricing.py. Сумму к оплате считает
 * сервер; здесь — только чтобы человек видел её до нажатия «Оплатить».
 * Разойдутся — в кассе окажется не та сумма, что на экране.
 */
export type DeliveryMethod = 'russia' | 'pickup';

export const DELIVERY_PRICE_RUB: Record<DeliveryMethod, number> = {
  russia: 500,
  pickup: 0,
};

export const DELIVERY_LABEL: Record<DeliveryMethod, string> = {
  russia: 'Доставка по России',
  pickup: 'Самовывоз в Москве',
};
